import React from 'react'
import '../Footer/Footer.css'
const Footer = () => {
  return (
    <>
 <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2024 Ace Residential. All rights reserved.</p>
        <div className="footer-links">
          <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
          <span className="footer-separator">|</span>
          <a href="/disclaimer" className="footer-link">Disclaimer</a>
        </div>
      </div>
    </footer>
    </>
  )
}

export default Footer